import React, { Suspense } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import config from '../config';

import navItems from './navItems';
import PagePath from './PagePath';
import TopLoader from '../Control/TopLoader/TopLoader';

import MainLayout from '../Backbone/layout/MainLayout';
import MinimalLayout from '../Backbone/layout/MinimalLayout';
import PageNotFound from '../Page/404/Page404';


import SessionHelper from '../Core/SessionHelper';
import ErrorBoundary from '../Control/ErrorBoundary';

const Routes = () => {
    const location = useLocation();
    const session = SessionHelper.GetSession();
    const isAuthenticated = Boolean(session && (session.AccessToken || session.AdminUserId || session.LoginId));
    const isSuperAdmin =
        session?.RoleName?.toLowerCase() === 'super admin' ||
        session?.RoleName?.toLowerCase() === 'admin' ||
        !session?.AllowedRoutePaths?.length;
    const allowedPaths = session?.AllowedRoutePaths || [];

    var flatItems = PagePath.GetFlatFromRecursive(navItems());

    // Filter showItems and standAlones based on RBAC
    var standAlones = flatItems.filter(i => i.IsStandAlone && Boolean(i.to));
    var showItems = flatItems.filter(
        i =>
            i.to &&
            !i.IsStandAlone &&
            (isSuperAdmin || allowedPaths.includes(i.to) || i.to === '/dashboard')
    );

    return (
        <AnimatePresence>
            <ErrorBoundary>
                <Suspense fallback={<TopLoader />}>
                    <Switch>
                        <Redirect exact from="/" to={isAuthenticated ? '/dashboard' : config.defaultPath} />
                        {isAuthenticated ? <Redirect exact from="/login" to="/dashboard" /> : null}
                        <Route path={standAlones.map(i => i.to || "")}>
                            <MinimalLayout>
                                <Switch location={location} key={location.pathname}>
                                    {standAlones.map(i => {
                                        const Component = i.Component;
                                        return Component ? (
                                            <Route
                                                exact
                                                key={i.label}
                                                path={i.to}
                                                render={() => <Component />}
                                            />
                                        ) : null;
                                    })}
                                </Switch>
                            </MinimalLayout>
                        </Route>
                        {!isAuthenticated ? <Redirect to="/login" /> : null}
                        <Route
                            path={showItems.map(i => i.to || "")}>
                            <MainLayout>
                                <Switch location={location} key={location.pathname}>
                                    {showItems.map(i => {
                                        const Component = i.Component;
                                        return Component ? (
                                            <Route
                                                exact
                                                key={i.label}
                                                path={i.to}
                                                render={() => <Component />}
                                            />
                                        ) : null;
                                    })}
                                </Switch>
                            </MainLayout>
                        </Route>
                        <Route component={PageNotFound} />
                    </Switch>
                </Suspense>
            </ErrorBoundary>
        </AnimatePresence>
    );
};

export default Routes;
